import React from 'react'
import Panel1 from './middle/Panel1'
import Panel2 from './middle/Panel2'

function LandingPageMiddle(){
    return ( <div>
               <Panel1 />
           </div>)
}

export default LandingPageMiddle